import { makeStyles, Theme } from '@material-ui/core'
import {
    AtlasGreyLight,
    AtlasWhite_100,
    ColorBaseMulberryBlue,
    ColorBaseRichBlack,
    ColorBaseWhite,
    ColorEastBay
} from 'assets/styles/variables'
import { AtlasGreyDark } from 'material-atlas/palette'

export const useMinutesTemplatesStyles = makeStyles((theme: Theme) => ({
    noDataContainer: {
        borderRadius: '12px',
        display: 'flex',
        padding: '24px',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '24px',
        alignSelf: 'stretch',
        placeContent: 'center',
        placeItems: 'center',
        textAlign: 'center',
        backgroundColor: ColorBaseWhite,
        height: '100%',
        minHeight: '400px'
    },
    noDataContainer1: {
        borderRadius: '12px',
        border: `1px solid ${AtlasGreyLight}`,
        display: 'flex',
        padding: '24px',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '24px',
        placeContent: 'center',
        placeItems: 'center',
        textAlign: 'center',
        backgroundColor: ColorBaseWhite,
        minHeight: '100px'
    },
    noDataTitle: {
        fontFamily: 'Source Sans Pro',
        fontSize: '28px',
        fontWeight: 600,
        lineHeight: '32px',
        textAlign: 'center',
        color: ColorBaseRichBlack
    },
    noDatabodyText: {
        fontFamily: 'Source Sans Pro',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '20px',
        textAlign: 'center',
        color: ColorBaseRichBlack,
        marginBottom: '24px'
    },
    buttonsContainer: {
        '& p': {
            fontFamily: 'Source Sans Pro',
            fontSize: '16px',
            fontWeight: 600,
            lineHeight: '20px',
            textAlign: 'center',
            color: ColorEastBay
        },
        '& span': {
            display: 'flex',
            gap: '8px'
        },

        height: '40px',
        padding: '8px 12px 8px 12px',
        gap: '8px',
        borderRadius: '2px 0px 0px 0px',
        border: `1px solid ${ColorEastBay}`,
        textTransform: 'none',
        '&:focus, &:active': {
            boxShadow: `0px 0px 0px 1px ${ColorBaseWhite}, 0px 0px 0px 3px ${ColorBaseMulberryBlue}`,
            borderRadius: '2px'
        }
    },
    buttonContainerSave: {
        '& p': {
            fontFamily: 'Source Sans Pro',
            fontSize: '16px',
            fontWeight: 600,
            lineHeight: '20px',
            textAlign: 'center',
            color: ColorEastBay
        },
        '& span': {
            display: 'flex',
            gap: '8px'
        },

        height: '40px',
        marginBottom: '23px',
        padding: '8px 12px 8px 12px',
        gap: '8px',
        borderRadius: '2px',
        border: `1px solid ${ColorEastBay}`,
        textTransform: 'none',
        '&:focus, &:active': {
            boxShadow: `0px 0px 0px 1px ${ColorBaseWhite}, 0px 0px 0px 3px ${ColorBaseMulberryBlue}`,
            borderRadius: '2px'
        }
    },
    filterBar: {
        display: 'grid',
        gridTemplateColumns: ({ numColumns }: any) =>
            numColumns === 3 ? '2.5fr 1fr 1fr' : numColumns === 2 ? '3fr 1fr' : '3fr',
        gap: '24px',
        padding: '12px 24px'
    },
    minutesDocumentsText: {
        fontFamily: 'Source Sans Pro',
        color: '#1e1e1e',
        fontWeight: 600,
        fontSize: '18px',
        margin: 'auto 0px auto 0px'
    },
    noMinutesText: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '22px',
        padding: '24px',
        minHeight: '68px',
        maxHeight: '98px',
        justifyContent: 'center',
        alignItems: 'center',
        height: '68px'
    },
    header: {
        justifyContent: 'space-between',
        alignItems: 'center',
        maxHeight: '100px',
        borderBottom: '1px solid #E6E6E6',
        padding: '24px',
        backgroundColor: '#FFFFFF',
        display: 'flex'
    },
    subHeaderText: {
        color: '#282E37',
        fontWeight: 600,
        fontSize: '28px',
        lineHeight: '32px'
    },
    subTitleText: {
        color: '#282E37',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '20px'
    },
    createMinutesContainerCls: {
        textTransform: 'none',
        backgroundColor: ColorEastBay,
        display: 'flex',
        color: '#fff',
        borderWidth: '0px',
        borderRadius: '3px',
        letterSpacing: '0.5px',
        fontFamily: 'Source Sans Pro',
        fontSize: '16px',
        padding: '8px 12px',
        fontWeight: 600,
        placeContent: 'center',
        gap: '8px',
        minWidth: '168px',
        '&:focus, &:active': {
            outline: 'none',
            boxShadow: `0px 0px 0px 1px ${ColorBaseWhite}, 0px 0px 0px 3px ${ColorBaseMulberryBlue}`,
            borderRadius: '2px',
            backgroundColor: `${ColorEastBay}`
        },
        '&:hover': {
            backgroundColor: '#364262',
            color: '#fff',
            cursor: 'pointer'
        }
    },
    createMinutesTxtCls: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        placeContent: 'center',
        gap: '5px'
    },
    center: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 'calc(100vh - 300px)'
    },
    root: {
        padding: '12px',
        margin: '18px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: 12,
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper
    },
    rootContainer: {
        borderRadius: 12,
        marginTop: '0px',
        marginBottom: '24px',
        marginLeft: '24px',
        marginRight: '24px',
        paddingBottom: '1px',
        paddingTop: '1px',
        backgroundColor: AtlasWhite_100
    },
    rootContainerCompany: {
        borderRadius: 12,
        margin: '24px',
        backgroundColor: AtlasWhite_100
    },
    iconBox: {
        display: 'flex',
        alignItems: 'center'
    },
    logo: {
        width: 36,
        height: 36,
        borderRadius: 8,
        display: 'inline-block',
        marginRight: '16px',
        marginLeft: '16px'
    },
    textBox: {
        display: 'flex',
        flexDirection: 'column'
    },
    title: {
        fontWeight: 600,
        fontSize: '16px',
        color: '#2e3b55',
        cursor: 'pointer'
    },
    subtitle: {
        color: AtlasGreyDark,
        fontSize: '16px',
        fontWeight: 400
    },
    rightSection: {
        display: 'flex',
        alignItems: 'center'
    },
    downloadButton: {
        fontSize: '14px',
        color: '#455D82',
        lineHeight: '18px',
        fontWeight: 600,
        marginRight: theme.spacing(2),
        textTransform: 'none',
        '&:focus, &:active': {
            outline: 'none',
            boxShadow: `0px 0px 0px 1px ${ColorBaseWhite}, 0px 0px 0px 3px ${ColorBaseMulberryBlue}`,
            borderRadius: '2px'
        }
    },
    allTemplatesText: {
        color: '#1E1E1E',
        fontFeatureSettings: "'liga' off, 'clig' off",
        fontFamily: 'Source Sans Pro',
        fontSize: 18,
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '24px',
        marginBottom: '24px',
        paddingLeft: '24px'
    },
    defaultTag: {
        backgroundColor: '#E6E6E6',
        padding: '5px 10px',
        textAlign: 'center',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 400,
        color: '#1E1E1E',
        marginRight: theme.spacing(2)
    },
    defaultTagHidden: {
        visibility: 'hidden'
    },
    companyContainer: {
        padding: '16px',
        margin: 0,
        borderRadius: 12,
        backgroundColor: theme.palette.background.paper
    },
    companyHeader: {
        marginBottom: '8px'
    },
    companyRow: {
        display: 'flex',
        gap: '16px',
        alignItems: 'center',
        flexWrap: 'nowrap',
        width: '100%'
    },
    companyLabel: {
        fontSize: '13px',
        color: '#1E1E1E'
    },
    companyDescription: {
        color: AtlasGreyDark,
        fontSize: '13px'
    },
    companyTextField: {
        width: '490px',
        minWidth: 0,
        height: 'auto',
        margin: 0,
        marginTop: '-17px',
        '& .MuiOutlinedInput-root': {
            marginTop: '0 !important'
        },
        '&.MuiFormControl-root': {
            marginTop: '17px',
            marginBottom: 0
        },
        '& p': {
            marginLeft: 0,
            marginRight: 0
        }
    },
    templateListContainer: {
        maxHeight: 'calc(-380px + 92vh)',
        marginRight: '18px',
        marginLeft: '18px',
        borderRadius: '12px',
        backgroundColor: AtlasWhite_100
    }
}))
